import { ContentArea } from '@calendly/ui/components/content-area';
import classNames from 'classnames';
import { ReactNode, useCallback } from 'react';
import { SHELL_CONTENT_SCROLL_ELEMENT_ID } from 'shared/constants/app_shell';
import { setShellContentScrollElement } from 'shared/shell_content_scroll_registry';
import { useCenterPanelLayoutContext } from './centerPanelLayoutContext';
import { PageFilterGradient, usePageFilterContext } from './pageFilterContext';
const centerPanelScrollCss = "c1bm7r8z";

/**
 * Phone edge-to-edge: sticky Displaying N owns Figma 16/12 above the meeting table.
 * Keep scroll flush — any padding-top here stacks under the count.
 * `&&` beats the base `padding: 0` shorthand when both classes are on the node.
 */
const centerPanelScrollEdgeToEdgeCss = "c8x1hfo";

/**
 * Phone edge-to-edge meetings: no ContentArea. CUI ContentArea's container-query
 * padding-inline wins over a parent `padding: 0` and was stacking with
 * MeetingsPhoneFeed (32px sides / inflated Displaying N gaps).
 */
const edgeToEdgeSlotCss = "e1uqk763";

/**
 * Scrollable center column between top and bottom chrome in `#shell-content`.
 * Scroll lives here, not on `#shell-content`. Layout mode is driven by `useCenterPanelLayout`.
 */
export const CenterPanelContent = ({
  children
}: {
  children: ReactNode;
}) => {
  const {
    layout
  } = useCenterPanelLayoutContext();
  const {
    isRendered: isPageFilterRendered,
    edgeToEdge
  } = usePageFilterContext();
  const setShellContentScrollRef = useCallback((node: HTMLDivElement | null) => {
    setShellContentScrollElement(node);
  }, []);
  return <div ref={setShellContentScrollRef} id={SHELL_CONTENT_SCROLL_ELEMENT_ID} className={classNames(centerPanelScrollCss, {
    [centerPanelScrollEdgeToEdgeCss]: edgeToEdge
  })} tabIndex={0} role="region" aria-label="Main content" data-edge-to-edge={edgeToEdge ? 'true' : undefined}>
      {/* Absolute fade — must not sit as a flex sibling of the scrollport. */}
      <PageFilterGradient />
      {edgeToEdge ? <div id="shell-content-slot" className={edgeToEdgeSlotCss}>
          {children}
        </div> : <ContentArea id="shell-content-slot" isWide={layout === 'wide'} padding={isPageFilterRendered ? 'inline' : 'full'}>
          {children}
        </ContentArea>}
    </div>;
};

require("./CenterPanelContent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CenterPanelContent.tsx");